// extracted by mini-css-extract-plugin
export var alignCenter = "_7b-d";
export var bannerShown = "_7b-6";
export var buttonContent = "_7b-0";
export var cardList = "_7b-1";
export var centerContent = "_7b-2";
export var chevron = "_7b-3";
export var closePanelButton = "_7b-k";
export var conversationContextContainer = "_7b-l";
export var conversationDetailContainer = "_7b-4";
export var detailWrapper = "_7b-7";
export var dropdownButton = "_7b-e";
export var dropdownTitle = "_7b-9";
export var fullHeight = "_7b-5";
export var hidden = "_7b-a";
export var icon = "_7b-b";
export var mergeSuggestionWrapper = "_7b-m";
export var panel = "_7b-i";
export var portalButtonsWrapper = "_7b-c";
export var right = "_7b-j";
export var tableSummaryContainer = "_7b-8";
export var tableSummaryHeader = "_7b-g";
export var threeDotsButton = "_7b-f";
export var wide = "_7b-h";